import {useMatch} from "react-router-dom";
import {capitalizeFirstLetter} from "../../../../../../util/string-util";

export interface ISongsMobileFilterHeaderLogic {
  returnLabel: string;
}

export const useSongsMobileFilterHeaderLogic = (): ISongsMobileFilterHeaderLogic => {
  const isBrowseTab = !!useMatch("/songs/browse/filter");
  const currentResults = isBrowseTab ? "browse" : "library";
  return {
    returnLabel: capitalizeFirstLetter(currentResults),
  };
}
